module.exports = __webpack_public_path__ + "static/media/success.5e25983e.mp3";